import { createI18n } from 'vue-i18n';

import en from './locales/en.json';

// type MessageSchema = typeof en;

const messages = {
  en,
};

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  globalInjection: true,
  messages,
});

export default i18n;
